import React, { useEffect, useState } from 'react';
import { Modal } from 'components/organisms/Modal';
import { Button, Loader } from 'legacy-components/componets';
import { useWindowSize } from 'hooks';
import { useStripeOnboarding } from 'legacy-pages/landlord/profile/context/StripeOnboardingProvider';
import { useUserProfile } from 'hooks/query';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const PayoutOnboardingUserActionRequiredDialog: React.FC<Props> = ({
  isOpen,
  onClose
}) => {
  const { isMobile } = useWindowSize();
  const { stripeConnectInstance, NotificationBannerComponent } = useStripeOnboarding();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { data: userProfile } = useUserProfile(); 
  const onComplete = async () => {
    setIsLoading(true);
    setShowOnboarding(true);
  };

  const handleCompleteLater = () => {
    onClose();
  };

  return (
    <Modal
      titleClassName='text-[22px]'
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      onClose={onClose}
      isFullScreen={isMobile}
      title={'Action Required - Additional Information Needed to Complete Stripe Verification'}
      contentClassName={'w-[750px]'}
    >
      {!showOnboarding ? (<div className='text-gray-700 text-base p-5'>
        <p className='mb-4'>
          Dear, {`${userProfile?.firstName} ${userProfile?.lastName}`},
        </p>
        <p className='mb-4'>
          Thank you again for completing your Stripe account registration.
        </p>
        <p className='mb-4'>
          Stripe has reviewed your account and <span className='font-bold'>requires additional information</span> to complete the verification process, which is necessary to enable secure online payment processing for lease transactions.
        </p>
        <p className='mb-4'>
          Please click the button below to provide the required details:
        </p>
        <p className='mb-4'>
          Completing this step will help avoid delays and ensure you can begin accepting move-in fee payments online as soon as possible.
        </p>
        <p className='mb-4'>
          As a reminder, once your account is approved, Stripe will allow renters to securely pay their move-in fees online after signing the lease. 
          As a landlord, you’ll benefit from:
        </p>
        <ul className='list-disc list-inside mb-4 space-y-1 pl-4'>
          <li>Instant transfer of move-in fee payments</li>
          <li>Secure and seamless payment processing</li>
          <li>Automated tracking of incoming payments</li>
        </ul>
        <p className='mb-6'>
          We appreciate your patience as Stripe completes the approval process.
        </p>
        <div className='flex flex-col md:flex-row md:justify-center gap-4'>
          <Button label='Complete Stripe Verification' onClick={onComplete} theme='primary'/>
          <Button label='Complete Later' onClick={handleCompleteLater} theme='secondary' />
        </div>
      </div>) : (
        <div>
          {isLoading && <Loader />}
          {stripeConnectInstance && <NotificationBannerComponent onLoaderStart={() => setIsLoading(false)} />}
        </div>
      )}
    </Modal>
  );
};
